import React from "react";
import CompanyProcessList from "../../../components/CompanyProcess/List/CompanyProcessList";
import { Link } from "react-router-dom";
import TopHeader from "../../../components/common/Header/TopHeader";

const CompanyProcessManage = () => {
  return (
    <main id="app">
            <TopHeader />
    <div className="company-process-management">
      <Link />
      <CompanyProcessList />
    </div>
    </main>
  );
};

export default CompanyProcessManage;
